/**
 * Check if API response status is successful
 * @param {Object} response - Axios response object
 * @returns {boolean} - True if status is 200 or 201
 */
export const isSuccessResponse = (response) => {
  return response.status === 200 || response.status === 201;
};

/**
 * Validate response and return data or throw error
 * @param {Object} response - Axios response object
 * @param {string} errorMessage - Custom error message
 * @returns {Object} - Response data
 */
export const validateResponse = (response, errorMessage = 'API request failed') => {
  if (isSuccessResponse(response)) {
    return response.data;
  }
  throw new Error(errorMessage);
};